import './ActionButton.css'
import {CSSProperties} from "react";
import {RpcState} from "../RpcState";
import React from 'react';
import {LoadingDots} from "./LoadingDots";

type ActionButtonProps = {
  secondary?: boolean,
  smaller?: boolean,
  disabled?: boolean,
  orange?: boolean,
  
  // Shows a spinner and makes this not clickable if pending.
  rpcState?: RpcState,
  
  onClick?: () => void,
  children?: any,

  // Hacks?
  extraClassNames?: string,
  extraStyles?: CSSProperties | undefined,
}

export const ActionButton = (props: ActionButtonProps) => {

  let classNames = 'ActionButton';

  if (props.secondary) {
    classNames += ' ActionButtonSecondary';
  }
  
  if (props.smaller) {
    classNames += ' ActionButtonSmaller';
  }
  
  if (props.orange) {
    classNames += ' ActionButtonOrange'; 
  }
  
  if (props.extraClassNames) {
    classNames += ' ' + props.extraClassNames;
  }
  
  return <button className={classNames} style={props.extraStyles}
                 onClick={props.onClick} disabled={props.disabled || props.rpcState?.state === 'pending'}>
    {props.rpcState?.state === 'pending' ? <LoadingDots/> : props.children}
  </button>
}